import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { mergeValuesIntoFields } from '@/utils/helpers';
import { FC, useEffect, useMemo, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

import PageContainer from '@/components/PageContainer';
import STEP_FIELDS from './stepFields.json';
import Form from '@/components/Form';

const TestPage: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { loading, data, updateAnswer, errorUpdate, loadingUpdate } = useOutletContext<any>();

  const step = Number(location.pathname.split('/').pop());

  const pageFields = STEP_FIELDS[step];

  const onSubmit = async (values) => {
    let newStep: string | number = step + 1;

    if (newStep > STEP_FIELDS.length - 1) {
      newStep = 'complete';
    }

    await updateAnswer(values);

    navigate(`../${newStep}`, {
      state: {
        step: newStep,
      },
    });
  };

  const enterListener = (e) => {
    if (e.key === 'Enter' && document.activeElement !== buttonRef.current) {
      e.preventDefault();
      buttonRef?.current?.click();
    }
  };

  useEffect(() => {
    if (!buttonRef.current) return;
    document.body.addEventListener('keydown', enterListener);
    return () => document.body.removeEventListener('keydown', enterListener);
  }, [buttonRef]);

  const { fields, buttonProps, containerProps } = pageFields;

  const mergeButtonProps = Object.assign(
    {},
    {
      fullWidth: false,
      children: 'Next',
      ref: buttonRef,
    },
    buttonProps
  );

  const innerFields = useMemo(() => mergeValuesIntoFields(data, fields), [data, fields]);

  return (
    <PageContainer key={step} loading={loading} sx={{ height: '100%' }}>
      <Box display="flex" flexDirection="column" justifyContent="center" height="100%" gap={1} {...containerProps}>
        <Form
          error={errorUpdate?.message}
          fields={innerFields}
          loading={loadingUpdate}
          onSubmit={onSubmit}
          buttonProps={mergeButtonProps}
        />
        <div>
          Or Press <Typography sx={{ fontWeight: 'bold', fontSize: 'small', display: 'inline' }}>ENTER</Typography>
          &nbsp;
          <Icon icon="mi:enter" width="20" />
        </div>
      </Box>
    </PageContainer>
  );
};

export default TestPage;
